// SCRUM-722: the pages slice (pagesSlice.ts) generates its own RTK action
// types; only the string below is still a contract. It is cross-slice by
// design — translationservice/types.js declares the same value:
// translationActions.transpagebyid dispatches it (reduced by the pages
// slice), and pagesSlice.getPageById dispatches it into translationReducer.
export const GET_PAGE_BY_ID = "GET_PAGE_BY_ID";
